import { useState } from "react";
import {
  BodyFrenteOrden,
  ContainerConfirmImage,
  ContainerFrenteOrden,
  ContainerSeleccionar,
  ContainerSubidaFrente,
  ContainerTopFrenteOrden,
  ContianerConsulta,
} from "./localStyle";

import imageOrden from "../../../assets/images/generico/OrdenMiniatura.png";
import { Camera, CameraResultType } from "@capacitor/camera";
import { getPlatforms } from "@ionic/react";

const FrenteOrden = ({ finalizarProceso, idTurno, dissmiss }) => {
  const [step, setStep] = useState("consulta"); //  selecionar || subidaFrente || confirmar
  const [cantidadOrdenes, setCantidadOrdenes] = useState(1);
  const [ordenActual, setOrdenActual] = useState(1);
  const [imageCamera, setImageCamera] = useState([]);

  const buttonConsulta = (success) => {
    if (success) setStep("seleccionar");
    else setStep("subidaFrente");
  };

  const onClickSelection = (e) => {
    const id = e.target.id;
    if (id === "btn-selection-1") {
      const btnOne = document.getElementById("btn-selection-2");
      btnOne.className = "selection";
      const btnTwo = document.getElementById("btn-selection-3");
      btnTwo.className = "selection";
      e.target.className = "selection active";
      setCantidadOrdenes(1);
    }
    if (id === "btn-selection-2") {
      const btnOne = document.getElementById("btn-selection-1");
      btnOne.className = "selection";
      const btnTwo = document.getElementById("btn-selection-3");
      btnTwo.className = "selection";
      e.target.className = "selection active";
      setCantidadOrdenes(2);
    }
    if (id === "btn-selection-3") {
      const btnOne = document.getElementById("btn-selection-2");
      btnOne.className = "selection";
      const btnTwo = document.getElementById("btn-selection-1");
      btnTwo.className = "selection";
      e.target.className = "selection active";
      setCantidadOrdenes(3);
    }
  };

  const handleClickAvanzar = () => {
    setStep("subidaFrente");
  };

  const capturarImagen = () => {
    const takePicture = async () => {
      try {
        const image = await Camera.getPhoto({
          quality: 50,
          allowEditing: true,
          resultType: CameraResultType.DataUrl,
        });
        const imageUrl = image.dataUrl;
        let lista = [...imageCamera];
        lista[ordenActual - 1] = imageUrl;
        setImageCamera(lista);
        setStep("");
      } catch (error) {
        console.log(error.message);
      }
    };
    takePicture();
  };

  const tipoImage = (url) => {
    url = url.split(",");
    const type = url[0].replace("data:image/", "").replace("base64", "");
    const base64 = url[1];

    return {
      type,
      base64,
    };
  };

  const handleClickConfirmarOrden = (success) => {
    const siguiente = ordenActual + 1;
    if (!success) {
      setStep("subidaFrente");
    } else {
      if (siguiente <= cantidadOrdenes) {
        setOrdenActual(siguiente);
        setStep("subidaFrente");
      } else {
        const listaDefinitiva = imageCamera.map((image) => {
          const obj = tipoImage(image);
          return {
            binario: obj.base64,
            idRemoto: idTurno,
            tag: obj.type,
            autocheck: true,
          };
        });
        finalizarProceso(listaDefinitiva);
      }
    }
  };

  let isMobile =
    getPlatforms()[0] === "android" ||
    getPlatforms()[0] === "ios" ||
    getPlatforms()[0] === "iphone"
      ? true
      : false;

  return (
    <ContainerFrenteOrden>
      <ContainerTopFrenteOrden>
        Frente de la orden
        <span className="cruz" onClick={dissmiss}>
          X
        </span>
      </ContainerTopFrenteOrden>
      <BodyFrenteOrden>
        {step === "consulta" ? (
          <ContianerConsulta>
            <h1>¿Cuenta con más de una orden para este turno?</h1>
            <div className="container-btn">
              <button onClick={() => buttonConsulta(false)} className="danger">
                NO
              </button>
              <button onClick={() => buttonConsulta(true)} className="success">
                {" "}
                SI
              </button>
            </div>
          </ContianerConsulta>
        ) : step === "seleccionar" ? (
          <ContainerSeleccionar isMobile={isMobile}>
            <h1>
              Seleccione la cantidad de ordenes con las que cuenta para este
              turno
            </h1>
            <div className="container-btn-selection">
              <button
                onClick={onClickSelection}
                className="selection"
                id="btn-selection-1"
              >
                1
              </button>
              <button
                onClick={onClickSelection}
                className="selection"
                id="btn-selection-2"
              >
                2
              </button>
              <button
                onClick={onClickSelection}
                className="selection"
                id="btn-selection-3"
              >
                3
              </button>
            </div>
            <button onClick={handleClickAvanzar} className="avanzar-btn">
              Avanzar
            </button>
          </ContainerSeleccionar>
        ) : step === "subidaFrente" ? (
          <ContainerSubidaFrente isMobile={isMobile}>
            <h1>Sacá o subí una foto del frente de la orden médica</h1>
            <span>
              Orden {ordenActual} de {cantidadOrdenes}
            </span>
            <img
              className="image-current"
              src={imageOrden}
              alt="orden médica"
            />
            <div className="container-btn">
              <button onClick={capturarImagen}>Subir</button>
              {/* <button onClick={capturarImagen}>Tomar Foto</button> */}
            </div>
          </ContainerSubidaFrente>
        ) : (
          <ContainerConfirmImage isMobile={isMobile}>
            <h1>¿El frente de orden se visualiza correctamente?</h1>
            <img
              className="image-current"
              alt="orden medica"
              src={imageCamera[ordenActual - 1]}
            />
            <div className="btn-container">
              <button
                onClick={() => handleClickConfirmarOrden(true)}
                className="success"
              >
                SI
              </button>
              <button
                onClick={() => handleClickConfirmarOrden(false)}
                className="danger"
              >
                NO
              </button>
            </div>
          </ContainerConfirmImage>
        )}
      </BodyFrenteOrden>
    </ContainerFrenteOrden>
  );
};

export default FrenteOrden;
